import { SVGProps } from 'react';

const SvgComponent = ({ height, width }: SVGProps<SVGSVGElement>) => (
  <svg width={height} height={width} viewBox="0 0 294 294" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_53_3845)">
      <rect width="294" height="294" fill="white" />
      <rect width="294" height="294" rx="14" fill="#FF643C" />
      <g clipPath="url(#clip1_53_3845)">
        <path
          d="M11.8342 11.1658C33.999 34.51 56.5323 57.8297 76.5838 83.0661C76.7189 83.2504 76.8787 83.4346 77.0138
          83.6189C106.833 121.326 106.833 174.698 77.0138 212.405C76.8664 212.602 76.7189 212.774 76.5715
          212.971C56.5323 238.195 33.999 261.514 11.8342 284.859L12.1537 285.178C35.4856 263.001 58.8053 240.468
           84.0417 220.441C84.2382 220.293 84.4102 220.146 84.6068 219.998C122.314 190.179 175.686 190.179 213.393
            219.998C213.578 220.134 213.762 220.293 213.946 220.429C239.183 240.48 262.49 263.001 285.847
            285.178L286.166 284.859C263.989 261.527 241.456 238.207 221.416 212.958C221.281 212.774 221.122
            212.59 220.986 212.405C191.167 174.698 191.167 121.326 220.986 83.619C221.122 83.4347 221.281 83.2504
            221.416 83.0661C241.456 57.8174 263.977 34.51 286.166 11.1658L285.846 10.8463C262.502 33.0111 239.183
            55.5444 213.946 75.5959C213.762 75.7311 213.578 75.8908 213.393 76.0259C175.686 105.845 122.314
            105.845 84.6068 76.0259C84.4225 75.8908 84.2382 75.731 84.0539 75.5959C58.8053 55.5567 35.4979
            33.0357 12.1537 10.8463"
          fill="#FF78D2" />
      </g>
      <path
        d="M164.431 151.79C164.431 151.79 112.472 146.879 163.375 222.463C163.375 222.463 124.038 182.395 124.038
        147.298C124.038 109.227 163.375 70.8567 163.375 70.8567C104.23 149.514 164.63 143.206 164.63 143.206L240
         137.656C238.169 74.2306 217.166 47.479 146.553 47.479C72.4372 47.479 53.4453 76.9058 53.4453 147.298C53.4453
         217.691 77.2748 247.118 146.792 247.118C216.31 247.118 237.969 220.167 239.98 156.242L164.411
          151.79L164.431 151.79Z"
        fill="#FFE600" />
    </g>
    <defs>
      <clipPath id="clip0_53_3845">
        <rect width="294" height="294" fill="white" />
      </clipPath>
      <clipPath id="clip1_53_3845">
        <rect width="387.495" height="387.495" fill="white" transform="translate(-125 148) rotate(-45)" />
      </clipPath>
    </defs>
  </svg>

);
export default SvgComponent;
